import React from 'react';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import MediaContainer from '../components/MediaContainer';
import useSEO from '../common/useSEO';

export default function Home() {
  useSEO({
    title: 'AARON FIGUEROA — Bay Area Videographer',
    description: 'Official portfolio of Aaron Figueroa, Bay Area videographer and founder of Bay Area Podcast Studio. Specializing in high-end video podcasts and executive messaging.',
    path: '/'
  });

  return (
    <div className="min-h-screen bg-[#000000] text-[#FFFFFF] font-sans selection:bg-[#FFFFFF] selection:text-[#000000]">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8">
        <Nav />

        <main className="w-full pb-12">
          {/* Capabilities Bar */}
          <div className="animate-capabilities flex flex-wrap justify-center items-center gap-[1.5rem] pt-[1.75rem] pb-[1.75rem] text-[clamp(1rem,1.8vw,1.5rem)] font-bold tracking-[0.08em] uppercase text-[#FFFFFF]">
            <span>VIDEO PODCASTS</span>
            <span className="text-[#333333] px-1">/</span>
            <span>IN-DEPTH INTERVIEWS</span>
            <span className="text-[#333333] px-1">/</span>
            <span>EXECUTIVE MESSAGING</span>
          </div>

          {/* Hero */}
          <div className="animate-hero w-full">
            <MediaContainer tag="AZITA MARTIN — VP, NVIDIA">
              <video autoPlay loop muted playsInline preload="metadata" loading="lazy"
                className="w-full h-full object-cover opacity-80 transition-opacity duration-1000 group-hover:opacity-100"
                src="https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/videos/dmlkZW8vcXVpY2t0aW1l/eaab321c0931a9e3003f37abcd8b0b32.mov"
              />
            </MediaContainer>
          </div>

          {/* Portfolio Grid */}
          <div className="animate-grid flex flex-col gap-[1.5rem] md:gap-[4rem] mt-[2.5rem] md:mt-[4rem]">

            {/* Row 1 */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-[1.5rem] md:gap-6">
              <MediaContainer tag="KARI BYRON — MYTHBUSTERS">
                <video autoPlay loop muted playsInline preload="metadata" loading="lazy"
                  className="w-full h-full object-cover opacity-80 transition-opacity duration-1000 group-hover:opacity-100"
                  src="https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/videos/dmlkZW8vcXVpY2t0aW1l/d140e2a7a3eca97d11140925fd5178af.mov"
                />
              </MediaContainer>
              <MediaContainer tag="MARCIN KLECZYNSKI — FOUNDER & CEO, MALWAREBYTES">
                <img
                  className="w-full h-full object-cover opacity-80 transition-opacity duration-1000 group-hover:opacity-100"
                  src="https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/images/aW1hZ2Uvd2VicA==/ecbab0292b5459a4a03f68f52ddf93dc.webp"
                  alt="Marcin Kleczynski"
                />
              </MediaContainer>
            </div>

            {/* Row 2 */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-[1.5rem] md:gap-6">
              <MediaContainer tag="JASON CONYARD — FORMER CIO, VMWARE">
                <img
                  className="w-full h-full object-cover opacity-80 transition-opacity duration-1000 group-hover:opacity-100"
                  src="https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/images/aW1hZ2UvcG5n/de045c85fbc71f56ee4e3a1f84a7f225.png"
                  alt="Jason Conyard"
                />
              </MediaContainer>
              <MediaContainer tag="SYLVIA ACEVEDO — FORMER CEO, GIRL SCOUTS">
                <img
                  className="w-full h-full object-cover opacity-80 transition-opacity duration-1000 group-hover:opacity-100"
                  src="https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/images/aW1hZ2UvcG5n/8690e5d41cabce7d1c091f8b66f000f3.png"
                  alt="Sylvia Acevedo"
                />
              </MediaContainer>
            </div>

            {/* Row 3: Full-Width Feature */}
            <div className="w-full">
              <MediaContainer tag="ADAM ROGERS — HOST OF ALIEN: EARTH — THE OFFICIAL PODCAST">
                <video autoPlay loop muted playsInline preload="metadata" loading="lazy"
                  className="w-full h-full object-cover opacity-80 transition-opacity duration-1000 group-hover:opacity-100"
                  src="https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/videos/dmlkZW8vcXVpY2t0aW1l/5e776ebd263f1db5b39716bfe24752b4.mov"
                />
              </MediaContainer>
            </div>

            {/* Row 4: Social Cuts */}
            <div className="w-full" style={{ borderTop: '1px solid #1F1F1F', paddingTop: '4rem' }}>
              <h2 className="text-[#888888] text-[0.75rem] uppercase tracking-[0.15em] mb-[1.5rem] font-medium">
                SOCIAL CUTS
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-[1.5rem] md:gap-6">
                <MediaContainer aspect="aspect-[9/16]" tag="VICTORIA DARZYNSKA">
                  <video autoPlay loop muted playsInline preload="metadata" loading="lazy"
                    className="w-full h-full object-cover opacity-80 transition-opacity duration-1000 group-hover:opacity-100"
                    src="https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/videos/dmlkZW8vbXA0/1dc878d5ef6027d6895ad4cf2d004962.mp4"
                  />
                </MediaContainer>
                <MediaContainer aspect="aspect-[9/16]" tag="FREMONT BANK">
                  <video autoPlay loop muted playsInline preload="metadata" loading="lazy"
                    className="w-full h-full object-cover opacity-80 transition-opacity duration-1000 group-hover:opacity-100"
                    src="https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/videos/dmlkZW8vbXA0/2d601cecc57d156a96f89646aacea094.mp4"
                  />
                </MediaContainer>
                <MediaContainer aspect="aspect-[9/16]" tag="NSTARX">
                  <video autoPlay loop muted playsInline preload="metadata" loading="lazy"
                    className="w-full h-full object-cover opacity-80 transition-opacity duration-1000 group-hover:opacity-100"
                    src="https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/videos/dmlkZW8vbXA0/55c8cd2d9571e42de6802a1aed602c7c.mp4"
                  />
                </MediaContainer>
              </div>
            </div>

            {/* Row 5 */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-[1.5rem] md:gap-6">
              <MediaContainer tag="CHARLES BILILIES — FOUNDER OF SOUVLA">
                <video autoPlay loop muted playsInline preload="metadata" loading="lazy"
                  className="w-full h-full object-cover opacity-80 transition-opacity duration-1000 group-hover:opacity-100"
                  src="https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/videos/dmlkZW8vcXVpY2t0aW1l/ba98355d036ae973b96193b46218dd36.mov"
                />
              </MediaContainer>
              <MediaContainer tag="DONNA RUFF — PRESIDENT, WRMSDC">
                <video autoPlay loop muted playsInline preload="metadata" loading="lazy"
                  className="w-full h-full object-cover opacity-80 transition-opacity duration-1000 group-hover:opacity-100"
                  src="https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/videos/dmlkZW8vcXVpY2t0aW1l/a5e87214f23febc2c9fc1d4a1d8ffdf0.mov"
                />
              </MediaContainer>
            </div>

          </div>
        </main>

        <Footer />
      </div>
    </div>
  );
}